import { useState, useLayoutEffect } from "react";

import { debounce } from "../utils";

/**
 * custome hook that returns current window size,
 * which is updated on triggering resize event every some delay
 * @param {Number} delay interval in ms to execute resize handler
 */
export const useWindowSize = (delay = 250) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const onResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  // TODO: it use deboune function, instead change useDebounce hook to also accept
  // a function, not just a value
  useLayoutEffect(() => {
    window.addEventListener("resize", debounce(onResize, delay), {
      passive: true,
    });

    return () => {
      window.removeEventListener("resize", debounce(onResize, delay), {
        passive: true,
      });
    };
  }, [delay]);

  return windowSize;
};
